import { SendDraftParams } from 'app/dataTypes/cafeteria/compensation/withdraw/toParent/draft'

import type { Request } from '../../../../index'


type ParamsApi = {
  withdraw_order_id: number
}

export const convertParams = ({ withdrawID }: SendDraftParams): [ParamsApi, null] => {
  return [{
    withdraw_order_id: parseInt(withdrawID, 10),
  }, null]
}

export const convertResult = (res: 'success'): boolean => {
  return !!res
}

export const POST_COMPENSATION_WITHDRAW_ORDERS_SEND_DRAFT: Request<SendDraftParams, boolean, void> = [
  'cabinet/compensation/withdraw_orders/send_draft',
  'post',
  ['data', 'result'],
]
